module.exports = __webpack_public_path__ + "img/validCode.cadd413d.svg";